import { Component, OnInit } from '@angular/core';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LetterRequestCustomerInbox',
  templateUrl: './LetterRequestCustomerInbox.component.html',
  styleUrls: ['./LetterRequestCustomerInbox.component.scss']
})
export class LetterRequestCustomerInboxComponent implements OnInit {

  Token:String=""
  Search_code_LetterRequestCustomerId:string=""
  Search_code_LetterRequestCustomer:string=""
  Search_persianDate_LetterRequestCustomer:string=""
  Search_customer_LetterRequestCustomer:string=""
  Search_Readed_LetterRequestCustomer:string=""
  Search_Order_LetterRequestCustomer:string=""
  Search_Section_LetterRequestCustomer:string=""

  Search_Order_LetterRequestCustomer_List:Array<string>=[]
  Search_Section_LetterRequestCustomer_List:Array<string>=[]

  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private LetterRequest_CustomerService:LetterRequestCustomerService,
    private Nav_Service:NavService,
  ) { }


  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  Data_Seleted_Delete:LetterRequestCustomer_List_Interface=Empty_LetterRequestCustomer_List_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1129).subscribe(
      data=>{
        setInterval(() => {
          if(this.Procssing==false)
          {
            this.ReadData_LetterRequestCustomer()
          }
        }, 10000);

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_LetterRequestCustomer(){
    this.Procssing=true
    this.LetterRequest_CustomerService.GetLetterRequestCustomerCustomerInbox(this.Token).subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data['result']
        this.Search_Order_LetterRequestCustomer_List=data['order']
        this.Search_Section_LetterRequestCustomer_List=data['section']
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

}
